/**
 * Standby Order Interface Component
 *
 * Simplified flow for standby (常備) products that always have stock.
 * We only need to capture the desired quantity without warehouse picking.
 */

import { __ } from '@wordpress/i18n';
import QuantitySelector from './QuantitySelector';

const StandbyOrderInterface = ({
    quantity,
    onQuantityChange,
    isMobile
}) => {
    const maxQuantity = 999; // Practical upper bound for manual entry

    return (
        <div className="fos-standby-section fos-fade-in">
            <div style={{
                textAlign: 'center',
                padding: '24px 20px',
                background: '#e8f5e9',
                border: '1px solid #81c784',
                borderRadius: '10px',
                marginBottom: '20px'
            }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>✅</div>
                <h4 style={{ margin: '0 0 8px', color: '#2e7d32' }}>
                    {__('常備商品', 'frontend-order-system')}
                </h4>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#2e7d32' }}>
                    {__('此商品庫存充足，直接輸入數量即可加入購物車。', 'frontend-order-system')}
                </p>
            </div>

            <div className="fos-quantity-section">
                <QuantitySelector
                    quantity={quantity}
                    maxQuantity={maxQuantity}
                    minQuantity={1}
                    onChange={onQuantityChange}
                    title={__('設定購買數量', 'frontend-order-system')}
                    isMobile={isMobile}
                    showQuickSelect={false}
                    showMaxLabel={false}
                    size="normal"
                />
            </div>
        </div>
    );
};

export default StandbyOrderInterface;
